/**
 * @generated SignedSource<<dc5c4d6c861e3f46a435eef251597749>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type StateMembershipSessionActivityArea = "community" | "curriculum" | "organization" | "product" | "%future added value";
export type AdminMembersReportDailyTimeSpentChartQuery$variables = {
  area: StateMembershipSessionActivityArea;
  id: string;
  productId?: string | null;
  startDate?: string | null;
};
export type AdminMembersReportDailyTimeSpentChartQuery$data = {
  readonly node: {
    readonly __typename: "OrganizationMembership";
    readonly __typename: "OrganizationMembership";
    readonly dailyTimeSpentReport: {
      readonly data: ReadonlyArray<{
        readonly date: string;
        readonly totalSessions: number;
        readonly totalTimeSpentSeconds: number;
      }> | null;
    };
    readonly id: string;
  } | {
    // This will never be '%other', but we need some
    // value in case none of the concrete values match.
    readonly __typename: "%other";
  } | null;
};
export type AdminMembersReportDailyTimeSpentChartQuery = {
  response: AdminMembersReportDailyTimeSpentChartQuery$data;
  variables: AdminMembersReportDailyTimeSpentChartQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "area"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "id"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "productId"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "startDate"
},
v4 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": [
    {
      "kind": "Variable",
      "name": "area",
      "variableName": "area"
    },
    {
      "kind": "Variable",
      "name": "productId",
      "variableName": "productId"
    },
    {
      "kind": "Variable",
      "name": "startDate",
      "variableName": "startDate"
    }
  ],
  "concreteType": "OrganizationMembershipReportingDailyTimeSpentReportResponse",
  "kind": "LinkedField",
  "name": "dailyTimeSpentReport",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "DailyTimeSpentPerDay",
      "kind": "LinkedField",
      "name": "data",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "date",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "totalTimeSpentSeconds",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "totalSessions",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "AdminMembersReportDailyTimeSpentChartQuery",
    "selections": [
      {
        "alias": null,
        "args": (v4/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v5/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              (v6/*: any*/),
              (v7/*: any*/)
            ],
            "type": "OrganizationMembership",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v3/*: any*/),
      (v0/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Operation",
    "name": "AdminMembersReportDailyTimeSpentChartQuery",
    "selections": [
      {
        "alias": null,
        "args": (v4/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v5/*: any*/),
          (v6/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              (v7/*: any*/)
            ],
            "type": "OrganizationMembership",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "6d490558e5c72d98e52a34ba694b9c21",
    "id": null,
    "metadata": {},
    "name": "AdminMembersReportDailyTimeSpentChartQuery",
    "operationKind": "query",
    "text": "query AdminMembersReportDailyTimeSpentChartQuery(\n  $id: ID!\n  $startDate: String\n  $area: StateMembershipSessionActivityArea!\n  $productId: ID\n) {\n  node(id: $id) {\n    __typename\n    ... on OrganizationMembership {\n      id\n      __typename\n      dailyTimeSpentReport(startDate: $startDate, area: $area, productId: $productId) {\n        data {\n          date\n          totalTimeSpentSeconds\n          totalSessions\n        }\n      }\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "8761cc3728eedea3a00a4c28c30cc940";

export default node;
